<template>
	<Row>
		<Col :span="12">
			<DividerAutoDirection>{{ $t('settings.about.versionsSubHeader') }}</DividerAutoDirection>
			<Skeleton :paragraph="{ rows: 6 }" :title="false" :loading="loading">
				<VerticalLayout size="small">
					<TypographyText v-for="version in statusData.versions" :key="version">{{ version }}</TypographyText>
				</VerticalLayout>
			</Skeleton>
		</Col>
		<Col :span="11" :offset="1">
			<DividerAutoDirection>{{ $t('settings.about.uptimeSubHeader') }}</DividerAutoDirection>
			<Skeleton :paragraph="{ rows: 6 }" :title="false" :loading="loading || statusData.started == null">
				<VerticalLayout size="small">
					<TypographyText>
						{{ $t('settings.about.startedTime') }}
						<DateTimeDisplay :date="statusData.started" />
					</TypographyText>
					<TypographyText>{{ $t('settings.about.uptime') }} {{ uptimeStr }}</TypographyText>
				</VerticalLayout>
			</Skeleton>
		</Col>
	</Row>
</template>

<script>
import { toRef, computed } from 'vue';
import { TypographyText, Row, Col, Skeleton } from 'ant-design-vue';

import { useNow, dateStrToDayJs, getDayJsDuration } from '@/components/common/dateUtils';

import { useI18n } from 'vue-i18n'

import VerticalLayout from '@/components/common/VerticalLayout';
import DateTimeDisplay from '@/components/common/DateTimeDisplay';
import DividerAutoDirection from '@/components/common/DividerAutoDirection.vue';

export default {
	components: {
		TypographyText, Row, Col, Skeleton,
		VerticalLayout, DateTimeDisplay,
		DividerAutoDirection,
	},
	props: ['loading', 'status'],
	setup(props) {
		const { locale } = useI18n();
		const statusData = toRef(props, 'status');
		const now = useNow();
		const uptimeStr = computed(() => {
			if (statusData.value.started == null) {
				return null;
			}
			const started = dateStrToDayJs(statusData.value.started);
			const duration = getDayJsDuration(started, now.value);
			return duration.locale(locale.value).humanize();
		});
		return {
			statusData,
			uptimeStr,
		};
	},
}
</script>
